import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import {
  ICondicaoPagamento,
  ICondicaoPagamentoParcela
} from '@app/modules/condicao-pagamento/models/condicao.model';
import { CondicaoService } from '@app/modules/condicao-pagamento/services/condicao.service';
import { IFormaPagamento } from '@app/modules/forma-pagamento/models/forma-pagamento.model';
import { FormaPagamentoService } from '@app/modules/forma-pagamento/services';
import { TabelaPrecoService } from '@app/modules/tabelapreco/services';
import { map } from 'rxjs/operators';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FastFormaPgmtComponent } from '../fast-forma-pgmt/fast-forma-pgmt.component';

@Component({
  selector: 'app-fast-cond-pgmt',
  templateUrl: './fast-cond-pgmt.component.html',
  styleUrls: ['./fast-cond-pgmt.component.scss'],
  providers: [TabelaPrecoService, FormaPagamentoService, CondicaoService]
})
export class FastCondPgmtComponent implements AfterViewInit {
  form_dados: UntypedFormGroup;

  form: UntypedFormGroup;

  parcelas_control: UntypedFormControl;

  forma_pagamento: IFormaPagamento[];

  dataSource = new MatTableDataSource<ICondicaoPagamentoParcela>([]);
  selection = new SelectionModel<ICondicaoPagamentoParcela>(false, []);

  public displayedColumns: string[] = [
    'numero',
    'forma_pagamento',
    'dias_prazo'
  ];

  loadingCodigo = true;
  viewInit = false;

  messages = {
    codigo: {
      required: 'O código é requerido.'
    },
    descricao: {
      required: 'Informar uma descrição é obrigatório.',
      maxlength: 'A descrição não pode conter mais que 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    }
  };

  constructor(
    private fb: UntypedFormBuilder,
    public tabPreco: TabelaPrecoService,
    protected tokenService: TokenService,
    public formaPagamentoService: FormaPagamentoService,
    private matDialog: MatDialog,
    private condicaoService: CondicaoService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<FastCondPgmtComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { entity: ICondicaoPagamento }
  ) {
    this.formaPagamentoService
      .getEntities(this.tokenService.getDomain().id)
      .pipe(
        map(forma =>
          forma.sort((a, b) => {
            if (a.codigo < b.codigo) return -1;
            if (a.codigo > b.codigo) return 1;
            return 0;
          })
        )
      )
      .subscribe(res => {
        this.forma_pagamento = res;
      });
  }

  ngOnInit(): void {
    const { entity } = this.data;
    this.form_dados = this.fb.group({
      descricao: [
        entity.descricao,
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      tabela_preco: [
        entity.tabela_preco,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ],
      catalogo_usa: [entity.catalogo_usa || false, [Validators.required]]
    });

    this.form = this.fb.group({
      dias_prazo: [
        null,
        [
          Validators.required,
          Validators.maxLength(3),
          CustomValidators.existSpecialChar()
        ]
      ],
      forma_pagamento: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ]
    });

    this.parcelas_control = new UntypedFormControl(
      [],
      [Validators.required, Validators.minLength(1)]
    );
  }

  verifyId() {
    const { codigo } = this.form_dados.controls;
    this.condicaoService
      .getEntitiesByParams(
        `codigo=${codigo.value}`,
        this.tokenService.getDomain().id
      )
      .subscribe(c => {
        if (c.length > 0) {
          codigo.setErrors({ repeated: true });
        }
      });
  }

  enterParcela(event) {
    if ((event.key === 'Enter' || event.keyCode === 13) && this.form.valid) {
      this.addParcela();
    }
  }

  reloadIndex(): void {
    const { value } = this.parcelas_control;
    this.parcelas_control.setValue(
      value.map((v, i) => ({ ...v, numero: i + 1 }))
    );
  }

  addParcela() {
    const { forma_pagamento, dias_prazo } = this.form.value;
    const { value: prevValue } = this.parcelas_control;
    this.parcelas_control.setValue([
      ...prevValue,
      { forma_pagamento_id: forma_pagamento.id, forma_pagamento, dias_prazo }
    ]);
    this.reloadIndex();
    this.dataSource.data = this.parcelas_control.value;
    this.form.controls.dias_prazo.reset();
    this.form.controls.forma_pagamento.reset();
  }

  removeParcela() {
    const { value: prevValue } = this.parcelas_control;
    const index = this.parcelas_control.value.findIndex(
      p => p.numero === this.selection.selected[0].numero
    );

    if (index >= 0) {
      prevValue.splice(index, 1);
      this.parcelas_control.setValue(prevValue);
    }
    this.reloadIndex();
    this.dataSource.data = this.parcelas_control.value;
    this.selection.clear();
  }

  addFormPagamento = () => {
    this.matDialog
      .open(FastFormaPgmtComponent, {
        // width: '700px',
        panelClass: [
          'dialog-sem-padding',
          'custom-container',
          'position-relative'
        ],
        position: {
          top: '50px'
        }
      })
      .afterClosed()
      .subscribe(entity => {
        if (entity) {
          this.form.controls.forma_pagamento.setValue(entity);
          this.forma_pagamento = [...this.forma_pagamento, entity];
        }
      });
  };

  submit() {
    const parcelas = this.parcelas_control.value;
    var data = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form_dados.value,
      tabela_preco_id: this.form_dados.value.tabela_preco.id,
      parcelas: this.parcelas_control.value.map(v => {
        return Utils.onlyAttributes(v, [
          'forma_pagamento_id',
          'dias_prazo',
          'numero'
        ]);
      })
    } as ICondicaoPagamento;
    data = Utils.trimAttributes(data);
    this.condicaoService
      .insert(
        Utils.onlyAttributes(data, [
          'domain_id',
          'codigo',
          'tabela_preco_id',
          'descricao',
          'parcelas',
          'catalogo_usa'
        ])
      )
      .subscribe(
        condicaoPagemento => {
          condicaoPagemento.parcelas = parcelas;
          this.snackBar.open(
            'Condição de pagamento cadastrada com sucesso',
            'X',
            {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            }
          );
          this.dialogRef.close(condicaoPagemento);
        },
        () => {
          this.snackBar.open(
            'Erro ao adicionar nova condicação de pagamento',
            'X',
            {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            }
          );
          this.dialogRef.close();
        }
      );
  }

  get totalParcelas(): number {
    return this.parcelas_control.value.length;
  }

  get formParcelasValid(): boolean {
    if (this.viewInit && this.parcelas_control.invalid)
      this.form.markAllAsTouched();
    return this.viewInit && this.parcelas_control.invalid;
  }

  get formDadosValid() {
    if (this.form_dados.invalid) this.form_dados.markAllAsTouched();
    return this.viewInit && this.form_dados.invalid;
  }

  get isValid(): boolean {
    return (
      this.viewInit && this.parcelas_control.valid && this.form_dados.valid
    );
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  get usaCatalogo() {
    return localStorage.getItem('usaCatalogo') === 'true';
  }
}
